export default "__VITE_ASSET__CQ6Qvmj6__"